const wowApp = require('angular').module('wowApp.shop');

wowApp.directive('wowCollectionTimeSwitch', ['ShopperService', 'CheckoutService', '$rootScope', 'StorePickerService', 'CollectionTimeService', require('./collection-time-switch-directive')]);
wowApp.service('CollectionTimeService', ['StorePickerService', require('./collection-time-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collection-time-switch/index.js
 **/